import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Button,
  TextField,
  TypableDropdown,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import { commonDropDownProps } from '../../atoms/ReportsCohortItem';

export const cellStyles4 = {
  color: patientAccessTheme.palette.text.mediumemphasis,
  fontSize: '14px',
  fontWeight: 400,
};

export interface AddInteractionModalProps {
  open?: boolean;
  handleClose?: () => any;
  handleSave?: () => any;
  isSaveButtonDisabled?: boolean;
  dataState: [any, React.Dispatch<React.SetStateAction<any>>];
  referrals: string[];
  onlyInputs?: boolean;
  update?: boolean;
  inputWidth?: string;
}

const AddInteractionModal: React.FC<AddInteractionModalProps> = ({
  open,
  handleClose,
  handleSave,
  isSaveButtonDisabled,
  dataState,
  referrals,
  onlyInputs,
  update,
  inputWidth,
}) => {
  const useStyles = makeStyles()({
    modal: {
      width: '553px',
      height: '480px',
      background: patientAccessTheme.palette.status.white,
      borderRadius: '8px',
      padding: '24px 24px 24px 24px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      flexDirection: 'column',
    },
    inputFieldsGrid: {
      width: '505px',
      marginTop: '20px',
      background: '#FBFBFE',
      padding: onlyInputs ? '0px' : '24px 24px 14px 24px',
      borderRadius: '8px',
    },
    selectFields: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: '10px',
    },
    cancelButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    saveButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border:
        '1px solid ' + isSaveButtonDisabled
          ? patientAccessTheme.palette.grey[500]
          : patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
  });
  const { classes } = useStyles();
  const constants =
    componentConstants.ORGANISMS.CARE_NAV_MODALS.ADD_INTERACTION;

  const [assignData, setAssignData] = dataState;

  const inputFields = () => {
    return (
      <Grid container className={classes.inputFieldsGrid}>
        <Grid className={classes.selectFields}>
          <Grid style={{ marginRight: '30px' }}>
            <ReportCreateNewLabelField
              label={constants.TYPE}
              component={
                <Dropdown
                  label={'Select'}
                  dropDownOptions={constants.TYPE_OPTIONS}
                  dropDownValues={constants.TYPE_OPTIONS}
                  value={assignData.type}
                  handleChange={(e) => {
                    setAssignData((prev: any) => ({
                      ...prev,
                      type: e.target.value,
                    }));
                  }}
                  selectStyles={{
                    ...commonDropDownProps.selectStyles,
                    width: inputWidth || '213px',
                  }}
                  labelTop="10px"
                />
              }
              required={true}
            />
          </Grid>
          <Grid>
            <ReportCreateNewLabelField
              label={constants.MODE}
              component={
                <Dropdown
                  label={'Select'}
                  dropDownOptions={constants.MODE_OPTIONS}
                  dropDownValues={constants.MODE_OPTIONS}
                  value={assignData.mode}
                  handleChange={(e) => {
                    setAssignData((prev: any) => ({
                      ...prev,
                      mode: e.target.value,
                    }));
                  }}
                  selectStyles={{
                    ...commonDropDownProps.selectStyles,
                    width: inputWidth || '213px',
                  }}
                  labelTop="10px"
                />
              }
              required={true}
            />
          </Grid>
        </Grid>
        <Grid className={classes.selectFields}>
          <Grid style={{ marginRight: '30px' }}>
            <ReportCreateNewLabelField
              label={constants.REFERRAL}
              component={
                <TypableDropdown
                  dropDownOptions={referrals}
                  dropDownValues={referrals}
                  placeholder={'Referral'}
                  value={assignData.referral}
                  handleChange={(e) => {
                    const value = e?.target?.value as string;
                    setAssignData((prev: any) => ({
                      ...prev,
                      referral: value,
                    }));
                  }}
                  handleInputChange={(value) => {
                    setAssignData((prev: any) => ({
                      ...prev,
                      referral: value,
                    }));
                  }}
                  disabled={false}
                  textFieldPlaceholder="Enter referral (or) select from below"
                  height="36px"
                  width={inputWidth || '213px'}
                  searchable={true}
                />
              }
            />
          </Grid>
          <Grid>
            <ReportCreateNewLabelField
              label={constants.DATE}
              component={
                <TextField
                  type="datetime-local"
                  width={inputWidth || '213px'}
                  placeholder={'date'}
                  value={assignData.interaction_date}
                  onChange={(e: any) => {
                    setAssignData((prev: any) => ({
                      ...prev,
                      interaction_date: e.target.value,
                    }));
                  }}
                />
              }
              required={true}
            />
          </Grid>
        </Grid>
        <Grid className={classes.selectFields}>
          <Grid>
            <ReportCreateNewLabelField
              label={constants.DETAILS}
              component={
                <TextField
                  value={assignData.details}
                  minRows={2}
                  multiline={true}
                  error={false}
                  placeholder={'Type here...'}
                  width={inputWidth ? '674px' : '460px'}
                  inputPropsStyle={{
                    padding: '16px',
                    height: 'auto',
                    overflow: 'auto',
                  }}
                  onChange={(e: any) => {
                    setAssignData((prev: any) => ({
                      ...prev,
                      details: e.target.value,
                    }));
                  }}
                />
              }
            />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  return onlyInputs ? (
    inputFields()
  ) : (
    <Modal open={open ?? false} onClose={handleClose}>
      <Grid container className={classes.modal}>
        <Grid>
          <Typography
            fontSize="18px"
            lineHeight="26px"
            fontType="semibold"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="4px 0px 0px 0px"
          >
            {update ? constants.UPDATE_TITLE : constants.TITLE}
          </Typography>
          <Typography
            fontSize="14px"
            lineHeight="24px"
            fontType="normal"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            margin="4px 0px 5px 0px"
          >
            {constants.SUB_TITLE}
          </Typography>
        </Grid>

        {inputFields()}

        <Grid
          container
          style={{
            position: 'absolute',
            bottom: 0,
            margin: '0px 0px 24px 240px',
          }}
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid style={{ marginRight: '12px' }}>
            <Button
              label={constants.CANCEL}
              variant="outlined"
              className={classes.cancelButton}
              onClick={handleClose}
            />
          </Grid>
          <Grid>
            <Button
              label={update ? constants.UPDATE : constants.SUBMIT}
              variant="contained"
              className={classes.saveButton}
              disabled={isSaveButtonDisabled}
              onClick={() => {
                handleSave && handleSave();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
export default AddInteractionModal;
